import { Reveal } from '@/components/Reveal/Reveal';
import { Section } from '@/components/Section/Section';
import { HOME_NUMBERS, HOME_WHO } from '@/dictionary/home';
import { HOME_ANCHORS } from '@/dictionary/routes';
import classes from './WhoSection.module.css';

/* אין וידאו רקע בסקשן הזה — כך גם באתר המקורי. */
export function WhoSection() {
  return (
    <Section id={HOME_ANCHORS.who.slice(1)}>
      <div className={classes.grid}>
        <Reveal>
          <div className={classes.copy}>
            <p className={classes.kicker}>{HOME_WHO.kicker}</p>
            <h2 className={classes.title}>
              {HOME_WHO.titleLead} <span className={classes.thin}>{HOME_WHO.titleThin}</span>
            </h2>
            <p className={classes.lead}>{HOME_WHO.lead}</p>
            {HOME_WHO.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <p>
              {HOME_WHO.highlightIntro}
              <strong>{HOME_WHO.highlightStrong}</strong>
            </p>
            <p>{HOME_WHO.closing}</p>
          </div>
        </Reveal>

        <Reveal delaySeconds={0.15}>
          <div className={classes.numbers}>
            {HOME_NUMBERS.map((item) => (
              <div key={item.label} className={classes.numberRow}>
                <span className={classes.numberValue}>
                  {item.value}
                  {'suffix' in item ? item.suffix : null}
                </span>
                <span className={classes.numberLabel}>{item.label}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
